import { useEffect, useState } from 'react'

const START_SECONDS = 23 * 3600 + 58 * 60 + 45

export type Countdown = {
  hours: string
  minutes: string
  seconds: string
}

export function useCountdown(): Countdown {
  const [remaining, setRemaining] = useState(START_SECONDS)

  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining((prev) => (prev <= 0 ? 0 : prev - 1))
    }, 1000)
    return () => window.clearInterval(id)
  }, [])

  const pad = (value: number) => String(value).padStart(2, '0')

  return {
    hours: pad(Math.floor(remaining / 3600)),
    minutes: pad(Math.floor((remaining % 3600) / 60)),
    seconds: pad(remaining % 60),
  }
}
